import React from 'react';
import RegisterEmpleadoForm from './RegisterEmpleadoForm';
import { useNavigate } from 'react-router-dom';

const RegisterEmpleadoPage = () => {
  const navigate = useNavigate();

  const handleVolver = () => {
    navigate('/');
  };

  return (
    <div>
      <RegisterEmpleadoForm onVolver={handleVolver} />
    </div>
  );
};

export default RegisterEmpleadoPage;
